<template>
  <div>
    <dart-select
      v-model="selectedLang"
      :options="supportedLanguages"
      :labels="supportedLanguagesLabel"
      @change="setLanguage"
      :lang-root="langRoot"
      :darkTheme="darkTheme"
      class="lang-select"
    >
      <template name="option" v-slot:option="slotProps">      
        <span>          
          <i8-icon
            v-if="slotProps && slotProps.isSelected"
            class="dart-select__option__icon"
            icon="agree"
            colour="white"
          />
        </span>
      </template>
    </dart-select>
  </div>
</template>
<script>
import i18n from '@shared/locale/locale';
import I8Icon from '@shared/components/I8Icon';
import DartSelect from '@shared/components/DartSelect';
import { mapGetters, mapActions } from 'vuex';

const name = 'language-select';
export default {
    name,
    componentName: name,
    components: {
        [DartSelect.name]: DartSelect,
        [I8Icon.name]: I8Icon,
    },
    props: {
        langRoot: {
            type: String,
            required: true,
        },
        darkTheme: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            selectedLang: i18n.locale,
        };
    },

    methods: {
        ...mapActions('locale', ['updateLocaleAndCookie']),

        setLanguage(lang) {
            this.updateLocaleAndCookie(lang);
        },
    },
    computed: {
        ...mapGetters('locale', ['getSupportedLanguages', 'getLocale']),

        supportedLanguages() {
            return this.getSupportedLanguages;
        },
        supportedLanguagesLabel() {
            let labels = {};
            this.$_.forEach(this.getSupportedLanguages, (lang) => {
                labels[lang.toLowerCase()] = this.$t(
                    `${this.langRoot}.${lang.toLowerCase()}`
                );
            });

            return labels;
        },
    },
};
</script>




// WEBPACK FOOTER //
// shared/components/LanguageSelect.vue